export const getAddressesMeta = (state) => state.addresses.meta